'use client';

import type React from 'react';
import styled from 'styled-components';
import isPropValid from '@emotion/is-prop-valid';
import type { BoxStyleOptions } from './box-styles';
import { boxStyles } from './box-styles';

/**
 * @deprecated `BoxProps` has been deprecated along with the `Box` component.
 * Use a `<div>` with CSS modules or inline styles instead.
 */
export type BoxProps = BoxStyleOptions &
  React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > & {
    css?: any;
  };

/**
 * @deprecated `Box` has been deprecated. Use a `<div>` with CSS modules or
 * inline styles instead.
 */
export const Box = styled.div.withConfig({
  shouldForwardProp: (propKeyname) =>
    propKeyname !== `display` &&
    propKeyname !== `color` &&
    isPropValid(propKeyname),
})<BoxProps>`
  ${boxStyles as any}
`;
